import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';

import * as userSelectors from '../../selectors/userSelectors';
import * as userConstants from '../../constants/user';
import OtherApplicationsPaths from '../../helpers/OtherApplicationsPaths';

import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import UserInfo from '../../components/users/UserInfo';
import Divider from '../../components/Divider';
import Avatar from '../../components/Avatar';
import { Tooltip } from '@material-ui/core';

class UserDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
        this.avatar = React.createRef();
    }

    onPopoverToggle = () => {
        this.setState(state => ({ open: !state.open }));
    };

    onPopoverClose = () => {
        this.setState({ open: false });
    };

    render() {
        const { currentUser, signOut, classes } = this.props;

        if (!currentUser) {
            return null;
        }

        return (
            <React.Fragment>
                <Tooltip title="Account options">
                    <div ref={this.avatar} onClick={this.onPopoverToggle}>
                        <Avatar
                            className={classes.avatar}
                            alt="user-image"
                            src={currentUser.pictureSmallURL}
                        />
                    </div>
                </Tooltip>
                <Popover
                    open={this.state.open}
                    onClose={this.onPopoverClose}
                    anchorEl={this.avatar.current}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    <React.Fragment>
                        <div className={classes.wrapper}>
                            <Avatar
                                className={classes.innerAvatar}
                                alt="user-image"
                                src={currentUser.pictureSmallURL}
                            />
                            <UserInfo user={currentUser} />
                        </div>
                        <Divider horizontal />
                        <div className={classes.actions}>
                            <Button
                                color="primary"
                                href={OtherApplicationsPaths.accounts.getPath()}
                                target="_blank"
                            >
                                MY ACCOUNT
                            </Button>
                            <Button onClick={signOut}>SIGN OUT</Button>
                        </div>
                    </React.Fragment>
                </Popover>
            </React.Fragment>
        );
    }
}

UserDropdown.propTypes = {
    currentUser: PropTypes.object,
    signOut: PropTypes.func.isRequired,
};

UserDropdown.defaultProps = {
    currentUser: undefined,
};

const mapDispatchToProps = dispatch => {
    return {
        signOut: () =>
            dispatch({
                type: userConstants.SIGN_OUT_REQUEST,
            }),
    };
};

const mapStateToProps = state => ({
    currentUser: userSelectors.getCurrentUser(state),
});

const style = ({ spacing }) => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        padding: spacing.unit * 3,
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    avatar: {
        marginLeft: 2 * spacing.unit,
        height: 36,
        width: 36,
        cursor: 'pointer',
    },
    innerAvatar: {
        width: 28,
        height: 28,
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectSheet(style)(UserDropdown));



// WEBPACK FOOTER //
// ./src/containers/userDropdown/UserDropdown.js